import { render, staticRenderFns } from "./winTheWarriors.vue?vue&type=template&id=f01ebf72&scoped=true&"
import script from "./winTheWarriors.vue?vue&type=script&lang=js&"
export * from "./winTheWarriors.vue?vue&type=script&lang=js&"
import style0 from "./winTheWarriors.vue?vue&type=style&index=0&id=f01ebf72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01ebf72",
  null
  
)

export default component.exports